const mixin = {
  data: function () {
    return {}
  },
  methods: {
    onUnityPoseError (code, message) {
      switch (code) {
        case 'restore-pose-sequence-fail':
          // TODO Pose sequence state is incorrect. Revert or clear completely and create new
          break
      }
    }
  }
}

export default mixin
